/**
 * Admin configuration for BCH Local.
 *
 * The admin pubkey controls the verified and sponsored merchants lists.
 * Only kind 30078 events from this pubkey are trusted.
 */
export const ADMIN_PUBKEY = 'df5bcaba9e74cc1764c9773ae160299dde5acf79416e2c96758dba225e6707cc';

/** The d-tag identifier for the verified merchants list event. */
export const VERIFIED_LIST_D_TAG = 'bch-verified-merchants';

/** The d-tag identifier for the sponsored merchants list event. */
export const SPONSORED_LIST_D_TAG = 'bch-sponsored-merchants';

/**
 * The d-tag for the admin-approved direct-listing pubkeys.
 *
 * Businesses added directly through BCH Local (paid, app-generated key) only
 * appear on the map once the admin adds their pubkey to this list. This is the
 * "make sure they're legit" gate on top of the on-chain payment.
 */
export const APPROVED_LISTINGS_D_TAG = 'bch-local-approved-listings';

/**
 * Blocked pubkeys — fake/test merchant accounts published during development.
 * These are filtered out of query results so they never appear in the app.
 */
export const BLOCKED_PUBKEYS: ReadonlySet<string> = new Set([
  // Old ephemeral admin publisher
  '357b1cfa69677cc55c0d1fd9a2e32dbb614b62030ec75be5a70e969fa604a522',
  // Fake: "Green Bean Coffee" (SF)
  'd65ce4d0e1c45ee63edefd32e9646d2b1fe866fb48ab70f9d326b9e88da33cfd',
  // Fake: "Tokyo Sushi House"
  'a4af2cc9abc05bd3adff4650c4a0627704519c769adb3a29b545a9142b1c8979',
  // Fake: "Berlin Beer Garden"
  'd40bf69b8216a6de7bd2f2cb80663fba7d3c7855aeda15a0cb07f9d12cb91b8c',
  // Fake: "Mercado BCH" (demo account)
  'd64027c629f944b02a900c2f439e3708642a9218fee086edb16e37df1edc3a19',
  // Fake: "My Store" (demo accounts — two were created)
  'aa08029759a9a69e173ecb7a81130bdcbcd87f67c126dd95b1ef2d70dcd9217a',
  '437a2c083dee89afb366c5701b38a5218ac924f4942df8430c0a40ee2160837b',
  // Fake: "Siam Street Eats" (demo account)
  'be680de7455a062a1b1479a72cab1fa52d22a196a5f7ad264f5d800f438e8d27',
  // Fake: "TechStore BA" (demo account)
  'a8875f7abc900e341d47e31ee49081bf2bebcf7b6d84fed980dd73e39a3e6023',
]);
